import { StickyEvent } from '../../modules/events/sticky/observer';
import { Page } from '../Page';

export class SearcherPage extends Page {
    public static render(): void {
        SearcherPage._observeStickyBreadCrumb();
        SearcherPage._moveSearchResultsNumber();
        SearcherPage._showPanelFilter();
        SearcherPage._hidePanelFilter();
    }

    private static _observeStickyBreadCrumb(): void {
        const breadcrumb = document.querySelector<HTMLElement>('.jomiba-breadcrumb');

        if (breadcrumb === null) {
            return;
        }

        document.addEventListener<any>('sticky-change', ({ detail: { target, stuck } }: CustomEvent<StickyEvent>) => {
            if (!breadcrumb.isSameNode(target)) {
                return;
            }

            const breadcrumbFacetsContainer = breadcrumb.querySelector<HTMLElement>('.region-breadcrumb__facets');
            const facetsContainer = document.querySelector<HTMLElement>('.view-search__header__facets');
            const searchHeader = document.querySelector<HTMLElement>('.view-search__header');

            if (
                facetsContainer === null
                || searchHeader === null
                || breadcrumbFacetsContainer === null
            ) {
                return;
            }

            if (stuck) {
                breadcrumbFacetsContainer.appendChild(facetsContainer);
            } else {
                searchHeader.appendChild(facetsContainer);
            }
        });
    }

    private static _moveSearchResultsNumber(): void {
        const main = document.querySelector<HTMLElement>('#main');
        const results = document.querySelector<HTMLElement>('.view-search__results');

        if (main === null || results === null) {
            return;
        }

        const iconFilter = document.createElement('span');
        iconFilter.className = 'material-icons iconoMostrarMenuLateral';
        iconFilter.textContent = 'filter_list';

        results.prepend(iconFilter);
        main.prepend(results);
    }

    private static _showPanelFilter(): void {
        const iconFilter = document.querySelector<HTMLElement>('.iconoMostrarMenuLateral');

        iconFilter?.addEventListener<any>('click', () => {
            if (document.body.classList.contains('menuLateralVisible')) {
                document.body.classList.remove('menuLateralVisible');
            } else {
                document.body.classList.add('menuLateralVisible');
            }
        });
    }

    private static _hidePanelFilter(): void {
        const aside = document.querySelector<HTMLElement>('aside');
        const blockAddFilter = document.querySelector<HTMLElement>('#block-add-filters');
        const close = blockAddFilter?.querySelector<HTMLElement>('.close');

        if (
            aside === null
        ) {
            return;
        }

        close?.addEventListener<any>('click', () => {
            if (document.body.classList.contains('menuLateralVisible')) {
                document.body.classList.remove('menuLateralVisible');
                aside.style.display = 'none';
            } else {
                document.body.classList.add('menuLateralVisible');
                aside.style.display = 'block';
            }
        });
    }
}
